import Utilities from "../utilities/utilities";

export default class videoModal {
	/**
	 * @param {Object} options - User options
	 */
	constructor(options) {
		window.addEventListener("DOMContentLoaded", () => {
			this.init();
		});

		window.addEventListener("NAVIGATE_IN", () => {
			this.init();
		});

		window.addEventListener("infiniteScrollAppended", () => {
			this.init();
		});
	}

	init() {
		var elName = ".js-video-modal-trigger";
		var $el = jQuery(elName);

		if ($el.length == 0) {
			return;
		}

		function toggle_video_modal() {
			// Click on video thumbnail or link
			jQuery(".js-video-modal-trigger").on("click", function (e) {
				// prevent default behavior for a-tags, button tags, etc.
				e.preventDefault();

				// Grab the video ID from the element clicked
				var id = jQuery(this).attr("data-youtube-id");

				// Autoplay when the modal appears
				// Note: this is intetnionally disabled on most mobile devices
				// If critical on mobile, then some alternate method is needed

				// String the ID and param variables together
				var src =
					"//www.youtube.com/embed/" +
					id +
					"?playlist=" +
					id +
					"&loop=1;rel=0&autoplay=1&controls=0&showinfo=0&modestbranding=1&theme=dark&fs=0&iv_load_policy=3";

				// Pass the YouTube video ID into the iframe template...
				// Set the source on the iframe to match the video ID
				jQuery("#youtube").attr("src", src);

				// Add class to the body to visually reveal the modal
				jQuery("body").addClass("show-video-modal overflow-hidden");
			});

			// Close and Reset the Video Modal
			function close_video_modal() {
				event.preventDefault();

				// re-hide the video modal
				jQuery("body").removeClass("show-video-modal overflow-hidden");

				// reset the source attribute for the iframe template, kills the video
				jQuery("#youtube").attr("src", "");
			}

			// if the 'close' button/element, or the overlay are clicked
			jQuery("body").on(
				"click",
				".close-video-modal, .video-modal .overlay",
				function (event) {
					// call the close and reset function
					close_video_modal();
				}
			);

			jQuery("body").on(
				"click",
				".js-video-modal-trigger-close",
				function (event) {
					jQuery(".video-modal-trigger, .video-modal").remove();
					Utilities.setCookie(
						"cookie-video-modal",
						"active",
						"0.041"
					);
				}
			);

			if (Utilities.getCookie("cookie-video-modal")) {
				jQuery(".video-modal-trigger, .video-modal").remove();
			}

			// if the ESC key is tapped
			jQuery("body").keyup(function (e) {
				// ESC key maps to keycode `27`
				if (e.keyCode == 27) {
					// call the close and reset function
					close_video_modal();
				}
			});
		}

		toggle_video_modal();
	}
}
